import {Trans} from '@lingui/macro';
import React, {FC, useCallback} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {
  ApplicationCredentialsModel,
  BasicApplicationCredentials,
} from '../../../../models/api/applicationCredentialsModel';
import {
  StyledParameterLineDiv,
  StyledParameterTitleLineDiv,
} from '../../../rules/ruleEditor/expressions/parameterLine';

interface ApplicationCredentialsBasicInputsProps {
  credentials: BasicApplicationCredentials;
  onUpdate: HandlerOf<ApplicationCredentialsModel>;
  isReadOnly: boolean;
}

export const ApplicationCredentialsBasicInputs: FC<ApplicationCredentialsBasicInputsProps> = ({
  credentials,
  onUpdate,
  isReadOnly,
}) => {
  const onUpdateUser = useCallback(
    (newUsername: string) => {
      onUpdate({...credentials, username: newUsername});
    },
    [credentials, onUpdate],
  );

  const onUpdatePassword = useCallback(
    (newPassword: string) => {
      onUpdate({...credentials, password: newPassword});
    },
    [credentials, onUpdate],
  );

  return (
    <>
      <StyledParameterLineDiv>
        <StyledParameterTitleLineDiv>
          <Trans id="server-editor-user-label">User</Trans>
        </StyledParameterTitleLineDiv>
        <TextBox
          value={credentials.username}
          onChange={onUpdateUser}
          size={VisualSizesEnum.MEDIUM}
          noMargin
          isDisabled={isReadOnly}
        />
      </StyledParameterLineDiv>

      <StyledParameterLineDiv>
        <StyledParameterTitleLineDiv>
          <Trans id="server-editor-password-label">Password</Trans>
        </StyledParameterTitleLineDiv>
        <TextBox
          value={credentials.password}
          onChange={onUpdatePassword}
          size={VisualSizesEnum.MEDIUM}
          noMargin
          isDisabled={isReadOnly}
        />
      </StyledParameterLineDiv>
    </>
  );
};
